module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ef1ded7e12c22605ba70f95382a96a13.png";